<template>
  <div v-if="loading"><scale-loader /></div>
  <tabs v-else-if="report_info" parent="report">
    <tab id="info" :name="translate('reports.info')" :href="url + '/info'">
      <Info :report="report_info" @update="get_report" />
    </tab>
  </tabs>
  <div v-else class="text-center">
    <p>{{ translate('no_data') }}</p>
    <router-link to="/report_list">{{ translate('reports.many') }}</router-link>
  </div>
</template>
<script>
import { Tabs, Tab } from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Index.vue'

export default {
  name: 'Report',
  components: { Tabs, Tab, Info },
  data() { return { report_info: null, loading: false, request_id: 0 } },
  computed: {
    cur_id() { return this.$route.params.report_id },
    url() { return '/report/' + this.cur_id }
  },
  activated() { this.get_report() },
  deactivated() {
    this.request_id++
    this.report_info = null
  },
  watch: {
    cur_id() {
      if (this.cur_id && this.$route.name === 'report_section') this.get_report()
    }
  },
  methods: {
    get_report() {
      const id = this.cur_id
      if (!id) return
      const request_id = ++this.request_id
      this.report_info = null
      this.loading = true
      this.$http.v1.getReportInfo(id, (response) => {
        if (request_id !== this.request_id || id !== this.cur_id) return
        this.report_info = response.data || null
      }).finally(() => {
        if (request_id === this.request_id) this.loading = false
      })
    }
  }
}
</script>
